import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import officeImage from "../../../assets/images/landing/features/about us.jpg";
const Info = () => {
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>About Us</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                

                                <Col lg={6} md={12}>
                                    {/* <h1 className="fw-bold text-primary">Why Offiso</h1> */}
                                    {/* <h5 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>Empowering Businesses with Seamless Procurement</h5> */}
                                    <p className="text-black"> <strong style={{fontSize:"20px"}}>Established in June 2022</strong>, now serves <strong>300+ clients</strong> across <strong>5 cities</strong> in India.</p>
                                    <p className="text-black"> <strong>One-stop corporate procurement</strong> – eliminating the hassle of multiple suppliers.</p>
                                    <p className="text-black"> <strong>Authorized distributor</strong> for <strong>vending machines, office essentials, corporate gifting, and more</strong>.</p>
                                    <p className="text-black"> <strong>Expert team</strong> of <strong>10 professionals</strong> with <strong>12+ years of experience</strong> in Corporate Services & Distribution.</p>
                                    <p className="text-black"> <strong>(DAAS) Distribution-As-A-Service</strong> – helping brands expand in corporate markets.</p>
                                    <p className="text-black"> <strong>Trusted vendor</strong> for IT, Manufacturing & Automotive companies.</p>
                                    <p className="text-black"> <strong>Expanding soon</strong> to Mumbai, Bengaluru, Hyderabad, Delhi & Chennai.</p>
                                </Col>
                                <Col lg={6} md={12} className="text-center">
                                    <img src={officeImage} alt="Office Space" className="img-fluid rounded" style={{width:"100%", height:"auto"}} />
                                </Col>
                            </Row>
                        </Col >
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default Info;